export default {
  /* AWS account */
  AWS_REPORTS_ACCOUNT_SELECTION: 'AWS_REPORTS_ACCOUNT_SELECTION',

  /* Reports */
  AWS_CLEAR_REPORT: 'AWS_CLEAR_REPORT',
  AWS_GET_REPORTS_REQUESTED: 'AWS_GET_REPORTS_REQUESTED',
  AWS_GET_REPORTS_SUCCESS: 'AWS_GET_REPORTS_SUCCESS',
  AWS_GET_REPORTS_ERROR: 'AWS_GET_REPORTS_ERROR',
  AWS_DOWNLOAD_REPORT_REQUESTED: 'AWS_DOWNLOAD_REPORT_REQUESTED',
  AWS_DOWNLOAD_REPORT_SUCCESS: 'AWS_DOWNLOAD_REPORT_SUCCESS',
  AWS_DOWNLOAD_REPORT_ERROR: 'AWS_DOWNLOAD_REPORT_ERROR'
};



// WEBPACK FOOTER //
// ./src/constants/aws/reportsTypes.js